import React from 'react'
import styled from 'styled-components'

import NumberFormat from 'react-number-format'

import { FONTS } from '../../constants'

export const NumberInput = ({ width, height, prefix, suffix, allowNegative = false, invalid = false, ...rest }) => {
  const _prefix = prefix !== undefined
  const _suffix = suffix !== undefined

  return (
    <Root
      width={ width }
      height={ height }
      prefix={ prefix }
      suffix={ suffix }
    >
      <NumberInputField
        _prefix={ _prefix.toString() }
        _suffix={ _suffix.toString() }
        allowNegative={ allowNegative }
        invalid={ invalid }
        { ...rest }
      />
    </Root>
  )
}

const Root = styled.div`
  width: ${p => p.width || '100%'};
  height: ${p => p.height || '30px'};
  position: relative;

  ${p => p.prefix && `
      ::before {
        position: absolute;
        content: '${p.prefix}';
        font-family: ${FONTS.GOTHAM};
        font-size: ${FONTS.SMALL_SIZE};
        color: #C4C4C4;
        transform: translate(10px, 38%);
      }
  `}

  ${p => p.suffix && `
      ::after {
        position: absolute;
        content: '${p.suffix}';
        font-family: ${FONTS.GOTHAM};
        font-size: ${FONTS.SMALL_SIZE};
        color: #C4C4C4;
        right: 5%; 
        transform: translate(0, 35%);
      }
  `}
`

const NumberInputField = styled(NumberFormat)`
    width: 100%;
    height: 100%;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #333333;
    border: 1px solid #C4C4C4;
    border-radius: 4px;
    padding: ${p => {
    if (p._prefix === 'true') return '0 12px 0 24px'
    else if (p._suffix === 'true') return '0 20px 0 12px'
    return '10px 12px'
  }};
    text-align: ${p => {
    if (p._suffix === 'true') return 'left'
    return 'right'
  }};

    ${p => p.invalid && `
      border: 1px solid #dc3545;
    `}

    ::placeholder {
      color: #C4C4C4;
    }

    :focus {
      outline: none;
      box-shadow: none;
      border: 1px solid #C4C4C4;
    }

    :disabled {
      background: #EAEAEA;
      color: #808080;
    }
`



// WEBPACK FOOTER //
// ./src/components/input/number-input.js